'use client'

import Link from 'next/link'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  const handleConsentClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    // Dispatch custom event to open consent dialog
    window.dispatchEvent(new Event('openConsent'))
  }

  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-column">
          <ul className="footer-links">
            <li>
              <a href="mailto:info@ne-room.com">INFO@NE-ROOM.COM</a>
            </li>
            <li>
              <address>
                NEROOM, LLC
                <br />
                Registered in Delaware, USA
                <br />
                131 Continental Dr, Suite 305
                <br />
                Newark, DE 19713
                <br />
                United States
              </address>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h3 className="footer-heading">PRODUCTS</h3>
          <ul className="footer-links">
            <li>
              <Link href="/products/nemenu">NEMENU</Link>
            </li>
            <li>
              <Link href="/products/nevision">NEVISION</Link>
            </li>
            <li>
              <Link href="/products/skyviona">SKY VIONA</Link>
            </li>
            <li>
              <Link href="/products/nefin">NEFIN</Link>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h3 className="footer-heading">LEGAL</h3>
          <ul className="footer-links">
            <li>
              <Link href="/terms">TERMS OF USE</Link>
            </li>
            <li>
              <Link href="/privacy">PRIVACY POLICY</Link>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h3 className="footer-heading">QUICK LINKS</h3>
          <ul className="footer-links">
            <li>
              <a href="#about">ABOUT</a>
            </li>
            <li>
              <a href="#services">SERVICES</a>
            </li>
            <li>
              <a href="#contact">CONSULTATION</a>
            </li>
            <li>
              <a href="#" onClick={handleConsentClick}>
                CONSENT
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h3 className="footer-heading">COMPANY</h3>
          <ul className="footer-links">
            <li>
              <Link href="/work">SELECTED WORK</Link>
            </li>
            <li>
              <Link href="/how-we-work">HOW WE WORK</Link>
            </li>
            <li>
              <Link href="/how-we-engage">HOW WE ENGAGE</Link>
            </li>
            <li>
              <Link href="/security">SECURITY</Link>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h3 className="footer-heading">SOCIAL MEDIA</h3>
          <div className="footer-social">
            <a href="https://linkedin.com/company/ne-room-llc/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-separator"></div>
      <div className="footer-copyright-container">
        <p className="footer-copyright">COPYRIGHT © {currentYear} NEROOM, LLC</p>
      </div>
    </footer>
  )
}
